module.exports = __webpack_public_path__ + "img/ca.a3b65ab1.svg";